import appModule from './app.module'
export default appModule.name
